import React from 'react';
import { IoSummaryCard } from './io-summary-card';
import { useCampaignContext } from '@/features/campaigns/campaign-context';
import { Button } from '@/components/display/button';

const ZOHO_CREATE_IO_URL =
  'https://crm.zoho.com/crm/org643932192/tab/CustomModule19/create?layoutId=2461504000130477043';

export function CampaignIOsRail() {
  const { ios, iosLoading, iosError } = useCampaignContext();

  if (iosError) {
    return <div className="text-red-500">Error loading insertion orders.</div>;
  }

  if (iosLoading) {
    return <div>Loading...</div>;
  }

  const handleCreateIOClick = () => {
    window.open(ZOHO_CREATE_IO_URL, '_blank');
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="rounded bg-gray-100 px-2 py-0.5 text-sm font-semibold text-gray-800">
        {ios.length === 0
          ? 'No IOs found for this Campaign'
          : `${ios.length} IO${ios.length > 1 ? 's' : ''}`}
      </div>
      {ios.length > 0 ? (
        ios.map((io, index) => <IoSummaryCard key={io.io_number || index} io={io} />)
      ) : (
        <div className="flex flex-col gap-1 pt-2 border-t-[1px] border-gray-300">
          <span className="ml-1 text-xs text-gray-500">Haven&apos;t created the IO yet?</span>
          <Button onClick={handleCreateIOClick} size="compact" className="w-fit">
            Create Insertion Order in Zoho
          </Button>
        </div>
      )}
    </div>
  );
}
